import React, { useEffect } from "react";
import { styleSheet } from "./style";
import { withStyles } from "@mui/styles";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllCategories } from "../../../redux/marketingCenter/digital";
import CategoriesSkelton from "../skelton/categories";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
function DigitalContent(props) {
  let { classes } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const categoriesList = useSelector(
    (state) => state.marketingCenter.digital.categoriesList
  );
  useEffect(() => {
    dispatch(getAllCategories({ medium: "Digital" }));
  }, []);
  return (
    <Box className={classes.digitalContentSectionArea}>
      <Box className={classes.digitalContentSection}>
        {categoriesList.isLoading ? (
          <CategoriesSkelton count={2} width="292px" />
        ) : categoriesList?.data?.length ? (
          categoriesList?.data?.map((item, index) => (
            <Box
              key={index}
              onClick={() =>
                navigate(`/marketing_center/digital/category/${item?._id}`)
              }
              className={classes.digitalContentSectionItem}
            >
              <Box className={classes.digitalContentSectionItemTop}>
                <img src={item.image} alt={item.name} />
              </Box>
              <Typography className={classes.digitalContentSectionItemContent}>
                {item.name}
              </Typography>
            </Box>
          ))
        ) : !categoriesList.isLoading ? (
          <Box className={classes.digitalContentSectionItem}>
            <Box
              className={classes.digitalContentSectionItemTop}
              sx={{ alignItems: "center !important" }}
            >
              <ErrorOutlineRoundedIcon
                sx={{ fontSize: "80px", color: "grey" }}
              />
            </Box>
            <Typography className={classes.digitalContentSectionItemContent}>
              {" "}
              Not Exists
            </Typography>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}

export default withStyles(styleSheet, { name: "DigitalContentStyles" })(
  DigitalContent
);
